export default "__VITE_ASSET__CJVkA4v6__"